export const propertyInformationMappings = {
  databaseName: 'Database',
  type: 'Availability',
  ownerName: 'Owner Name',
  ownerEmail: 'Owner Email',
  ownerPhone: 'Owner Phone',
  city: 'City',
  state: 'State',
  zip: 'Zip Code',
  county: 'County',
  numberOfUnits: 'Number of Units',
  size: 'Building Size (SF)',
  lotSize: 'Lot Size',
  yearBuilt: 'Year Built',
  buildingClass: 'Building Class',
  propertySubtype: 'Property Subtype',
  yearRenovated: 'Year Renovated',
  propertyType: 'Property Types',
  investmentType: 'Investment Type'
};

export const saleInformationMappings = {
  buyer: 'Buyer',
  seller: 'Seller',
  salePrice: 'Sale Price',
  saleDate: 'Sale Date',
  loanAmount: 'Loan Amount',
  saleCapRate: 'Sale Comp Cap Rate',
  saleNOI: 'Sale Comp NOI',
  salePricePerUnit: 'Sale Comp Price Per Unit'
};

export const propertyHistoryMappings = {
  createdAt: 'Created On',
  createdBy: 'Created By',
  lastUpdatedAt: 'Updated On',
  lastUpdatedBy: 'Updated By'
};

export const leaseInformationMappings = {
  tenant: 'Tenant',
  leaseSuiteNumber: 'Lease Suite Number',
  leaseSize: 'Lease Size (SF)',
  leaseCommencement: 'Lease Commencement Date',
  leaseExecutionDate: 'Lease Execution Date',
  leaseExpiration: 'Lease Expiration Date',
  leaseRate: 'Lease Rate',
  leaseSpaceType: 'Lease Space Type'
};

export const projectInformationMappings = {
  projectDealStatus: 'Sale Listing Availability',
  projectCapRate: 'Cap Rate',
  projectNoi: 'NOI',
  projectSalePrice: 'Sale Price',
  projectSalePricePerUnit: 'Price / Unit'
};

export const researchInformationMappings = {
  propertyInformation: {
    title: 'Property Information',
    mappings: propertyInformationMappings,
    key: 'property-information'
  },
  saleInformation: {
    title: 'Sale Comp Information',
    mappings: saleInformationMappings,
    key: 'sale-information'
  },
  leaseInformation: {
    title: 'Lease Comp Information',
    mappings: leaseInformationMappings,
    key: 'lease-information'
  },
  projectInformation: {
    title: 'Sale Listing Information',
    mappings: projectInformationMappings,
    key: 'project-information'
  },
  historyInformation: {
    title: 'History',
    mappings: propertyHistoryMappings,
    key: 'history-information'
  }
};

export const defaultColumnMappings = {
  name: 'Property Name / Address'
};

export const sortableColumnTypes = {
  nameAddress: 'alpha',
  city: 'alpha',
  state: 'alpha',
  zip: 'amount',
  numberOfUnits: 'amount',
  size: 'amount',
  lotSize: 'amount',
  yearBuilt: 'amount',
  buildingClass: 'alpha',
  yearRenovated: 'amount',
  createdAt: 'amount',
  createdBy: 'alpha',
  lastUpdatedAt: 'amount',
  lastUpdatedBy: 'alpha'
};

// These are unsortable columns
// TODO: Rename this and associated props
export const excludedColumns = [
  'activeDealCount',
  'activeEdgeProjectCount',
  'ownerName',
  'ownerEmail',
  'ownerPhone',
  'databaseName',
  'type',
  'buyer',
  'seller',
  'salePrice',
  'saleDate',
  'loanAmount',
  'saleCapRate',
  'saleNOI',
  'salePricePerUnit',
  'tenant',
  'leaseSuiteNumber',
  'leaseSize',
  'leaseCommencement',
  'leaseExecutionDate',
  'leaseExpiration',
  'leaseRate',
  'leaseSpaceType',
  'projectDealStatus',
  'projectCapRate',
  'projectNoi',
  'projectSalePrice',
  'projectSalePricePerUnit',
  'propertyType',
  'investmentType'
];
